import { observable, action } from 'mobx';
import agent from '../agent';
import Moment from 'moment';
import * as CompanyEmailValidator from 'company-email-validator';
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const phoneRegex = /^[1-9]\d{10}/;

const nameRegex = /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/;
try {
    if (window.localStorage) {
        window.local_Storage = window.localStorage;
    }
} catch (e) {
    console.log('error in localstorage', e)
    window.local_Storage = {
        _data: {},
        setItem: function (id, val) { return this._data[id] = String(val); },
        getItem: function (id) { return this._data.hasOwnProperty(id) ? this._data[id] : undefined; },
        removeItem: function (id) { return delete this._data[id]; },
        clear: function () { return this._data = {}; }
    };
    console.log('Setting Manual Local Storage')
}
export class CommonStore {

    @observable appLoaded = false;
    @observable rateLimitingList = []
    @observable sideDrawer = false;
    @observable snackbarOptions = {
        open: false,
        message: ''
    };
    @observable dialogOptions = {
        dialogOpen: false,
        type: ''
    }
    @observable currentStore = '';  //current store to keep track
    @observable goodToGo = false;
    @observable noNet = false;
    @observable activeTab = "Home"
    @observable helpDialog = false;
    @observable kbResult = {};
    @observable kbDownloadLink = '';
    @observable searchProgress = false;
    @observable inProgress = false;
    @observable requestProgress = false;
    @observable statistics = {};
    @observable chatStatistics = {};
    @observable faqList = [];
    @observable totalFaqs = 0;
    @observable stats = {}
    @observable locationInfo = {}
    @observable startDate = Moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD-MMM-YYYY');
    @observable endDate = Moment(new Date()).format('DD-MMM-YYYY');
    @observable error = false
    @observable selectionRange = {
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
    }

    @observable freeSlotsData = {}

    constructor() {
        let locationInfo = window.local_Storage.getItem('locationInfo');
        if (locationInfo && JSON.parse(locationInfo).hasOwnProperty('ip')) {
            this.locationInfo = JSON.parse(locationInfo)
        }
    }

    @action handleDrawerToggle = () => {
        this.sideDrawer = !this.sideDrawer
    }

    @action setDateRange(ranges) {
        this.selectionRange = ranges.selection
        this.startDate = Moment(ranges.selection.startDate).format('DD-MMM-YYYY')
        this.endDate = Moment(ranges.selection.endDate).format('DD-MMM-YYYY')
    }

    @action openHelpDialog(value) {
        this.helpDialog = value
    }

    @action validateEmail(email) {
        if (!email || !CompanyEmailValidator.isCompanyEmail(email))
            return false;
        return true;
    }

    @action validateText(name) {
        if (!name || !nameRegex.test(name))
            return false;
        return true;
    }

    @action setActiveTab(active) {
        this.activeTab = active
    }

    @action openTrashFlag() {
        this.openTrash = true;
    }
    @action closeTrashFlag() {
        this.openTrash = false;
    }
    @action setAppLoaded() {
        this.appLoaded = true;
    }

    @action handleOpenSnackBar(message, type) {
        this.snackbarOptions.open = true;
        this.snackbarOptions.message = message;
        this.snackbarOptions.type = type;
    }

    @action handleCloseSnackBar() {
        this.snackbarOptions.open = false;
        this.snackbarOptions.message = '';
    }

    @action openDialog(dialogType) {
        this.dialogOptions.dialogOpen = true;
        this.dialogOptions.type = dialogType;
    }

    @action closeDialog() {
        this.dialogOptions.dialogOpen = false;
        this.dialogOptions.type = '';
    }

    @action setCurrentStore(storeValue) {
        this.goodToGo = true;
        this.currentStore = storeValue;
    }

    @action resetFlag() {
        this.goodToGo = false;
    }

    @action setNoInternet() {
        this.noNet = true;
    }
    @action resetNoInternet() {
        this.noNet = false;
    }

    @action modifyText = (text) => {
        let temp = []
        text.split("_").length && text.split("_").forEach(word => {
            word = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            temp.push(word)
        })
        return temp.join(" ")
    }

    @action getStats() {
        this.inProgress = true;
        return agent.Stats.getStats()
            .then(action((response) => {
                if (response.statusCode == "200") {
                    this.stats = response.data
                }
            }))
            .catch(action((err) => {
            }))
            .finally(action(() => {
                this.inProgress = false;
            }))
    }

    @action showFreeSlots(month, timezone) {
        this.inProgress = true;
        return agent.Calendar.showFreeSlots(month, timezone)
            .then(action((response) => {
                if (response.statusCode == "200") {
                    this.freeSlotsData = response.data
                }
            }))
            .catch(action((err) => {
            }))
            .finally(action(() => {
                this.inProgress = false;
            }))
    }

    @action getLocationInfo() {
        this.inProgress = true;
        return agent.Calendar.getLocationInfo()
            .then(action((response) => {
                if (response.ip)
                    this.locationInfo = response
                window.local_Storage.setItem('locationInfo', JSON.stringify(response));

            }))
            .catch(action((err) => {
            }))
            .finally(action(() => {
                this.inProgress = false;
            }))
    }

    @action validatePhone(ph) {
        if (!ph || !phoneRegex.test(ph))
            return false;
        return true;
    }


    @action bookSlot(info, emails, slotTime, durationMinutes, timeZone) {
        this.inProgress = true;
        let emailIds = JSON.parse(JSON.stringify(emails))
        this.error = false
        emailIds.unshift(info.emailId)
        let dur = durationMinutes === 'thirtyMin' ? "30" : "60"
        let temp = {
            firstName: info.name,
            lastName: info.lastName,
            emailIds, slotTime, timeZone,
            phone: info.phone,
            company: info.company,
            note: info.note,
            durationMinutes: dur,
            product: info.product,
            city: this.locationInfo.city,
            state: this.locationInfo.region,
            country: this.locationInfo.country
        }
        return agent.Calendar.bookSlot(temp)
            .then(action((response) => {
                if (response.statusCode == "200") {

                }
                else {
                    this.error = true
                    this.handleOpenSnackBar(response.message, 'error')
                    this.inProgress = false
                }
            }))
            .catch(action((err) => {
            }))
            .finally(action(() => {
                this.inProgress = false;
            }))
    }

    @action registerForTrial(info) {
        this.inProgress = true;
        this.error = false
        let temp = {
            firstName: info.name,
            lastName: info.lastName,
            phoneNumber: info.phone,
            emailId: info.emailId,
            jobTitle: info.jobTitle.trim().length ? info.jobTitle : undefined,
            privacyConsent: true,
            useCase: info.useCase && info.useCase.trim().length ? info.useCase : undefined,
            companyName: info.company,
            otp: info.otp
        }
        return agent.Trial.register(temp)
            .then(action((response) => {
                if (response.statusCode == "201") {
                    return ({ success: true })
                }
                else {
                    this.error = true
                    this.handleOpenSnackBar(response.message, 'error')
                    this.inProgress = false
                    return ({ success: false })

                }
            }))
            .catch(action((err) => {
                if (err.response && err.response.body && err.response.body.message)
                    this.handleOpenSnackBar(err.response.body.message, 'error')
                else
                    this.handleOpenSnackBar('Failed to register trial request', 'error')
                this.inProgress = false;
            }))
            .finally(action(() => {
                this.inProgress = false;
            }))
    }

    @action requestOtp(email) {
        this.requestProgress = true;
        this.error = false
        
        return agent.Trial.requestOtp(email)
            .then(action((response) => {
                if (response.statusCode == "200") {
                    this.handleOpenSnackBar('OTP has been sent to your Email', 'success')
                    return ({ success: true })
                }
                else {
                    this.error = true
                    this.handleOpenSnackBar(response.message, 'error')
                    this.requestProgress = false
                    return ({ success: false })

                }
            }))
            .catch(action((err) => {
                if (err.response && err.response.body && err.response.body.message)
                    this.handleOpenSnackBar(err.response.body.message, 'error')
                else
                    this.handleOpenSnackBar('Failed to request OTP', 'error')
                this.requestProgress = false;
            }))
            .finally(action(() => {
                this.requestProgress = false;
            }))
    }


}
export default new CommonStore();
